// dependencies
import React from "react";
import { Map, List } from "immutable";

// components
import BarChart from "Components/Graphs/BarChart";
import UtilChart from "Components/Graphs/UtilizationChart";

export default Map({
	graphs: List([
		Map({
			label: "Most Active Companies",
			name: "mostActiveCompanies",
			url: "most-active-companies",
			processName: "GetMostActiveCompanies",
			component: (props) => <BarChart {...props} />,
		}),
		Map({
			label: "Lambda Jobs",
			name: "lambdaJobs",
			url: "lambda-jobs",
			processName: "GetLambdaJobs",
			component: (props) => <div {...props} />,
		}),
		Map({
			label: "Company Utilization",
			name: "test",
			url: "company-utilization",
			processName: "GetMostActiveUtilization",
			component: (props) => <UtilChart {...props} />,
		}),
	]),
	activeGraph: null,
	activeGraphData: Map(),
});
